<template>
  <div class="card card-plain">
    <div class="pb-0 card-header text-start">
      <h4 class="font-weight-bolder" style="color: #0385F3;">Buat Kata Sandi</h4>
      <p class="mb-0">Buat kata sandi untuk melindungi akun kamu</p>
    </div>
    <div class="card-body">
      <form @submit.prevent="submit()">
        <div class="mb-3">
          <FormGroup>
            <InputForm type="password" v-model="form.password" name="password" placeholder="Tulis kata sandi" :showable="true" />
            </FormGroup>
            <div class="">
                <small>
                  <small>
                    <checklist-password :data="form.password" />
                  </small>
                </small>
            </div>
        </div>
        <div class="mb-3">
          <FormGroup>
            <InputForm type="password" v-model="form.repassword" name="repassword" placeholder="Tulis ulang kata sandi" :showable="true" />
          </FormGroup>
        </div>

        <div class="text-center">
          <argon-button class="mt-4" variant="gradient" fullWidth size="lg">Buat Kata Sandi</argon-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import AuthApi from "@/repository/api/AuthApi";
import ChecklistPassword from "@/components/ChecklistPassword.vue";
import FormGroup from '../../components/FormGroup.vue';
import InputForm from '../../components/InputForm.vue';
const body = document.getElementsByTagName("body")[0];

export default {
  name: "verification",
  components: {
    ArgonButton,
    ChecklistPassword,
    FormGroup,
    InputForm,
  },
  data() {
    return {
      form: {
        password: "",
        repassword: "",
      },
    }
  },
  async mounted() {
    await this.checkverificationtoken();
  },
  methods: {
    async checkverificationtoken() {
      this.$store.state.loading = true;
      await AuthApi.checkverificationtoken(this.$route.params.token).catch((error) => {
        this.$swal({
          icon: "error",
          title: error.response.data.message,
        }).then(() => {
          this.$router.push({ name: "Signin" })
        });
      })
      this.$store.state.loading = false;

    },
    async submit() {
      this.$store.state.loading = true;
      await AuthApi.verification(this.$route.params.token, this.form).then(async () => {
        this.$swal({
          icon: "success",
          title: "Success",
        }).then(() => {
          localStorage.removeItem('token');
          this.$store.state.token = "";
          this.$router.push({ name: "Signin" })
        })
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
        });
      })
      this.$store.state.loading = false;
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
